<app-offcanvas-base
  [returnUrl]="returnUrl"
  [returnParams]="params">
  <ng-container title>
    <app-offcanvas-header-btn title="Edit employee details"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    <app-employee-form class="offcanvas-body-inner" />
  </ng-container>
</app-offcanvas-base>
